<elder-table
  class="flex"
  [data]="configurationsPopulated$ | async"
  [selectionVisible]="true"
  [selectionMultiEnabled]="true"
  (itemClick)="onConfigurationClicked($event)"
  matSort
>
  <elder-data-toolbar
    *elderTableToolbar
    [canAdd]="true"
    [canRemove]="true"
    [canMore]="false"
    (requestNew)="addConfiguration()"
    (requestRemove)="onRemoveConfiguration($event)"
  >
  </elder-data-toolbar>

  <!-- icon -->
  <ng-container matColumnDef="icon">
    <th mat-header-cell *matHeaderCellDef style="width: 10%"></th>
    <td mat-cell *matCellDef>
      <mat-icon>label</mat-icon>
    </td>
  </ng-container>

  <!-- property id Column -->
  <ng-container matColumnDef="spec-id">
    <th mat-header-cell *matHeaderCellDef style="width: 20%" mat-sort-header>
      {{ 'properties.property' | translate }}
    </th>
    <td mat-cell *matCellDef="let configuration">
      <div class="layout-col" matTooltip="PropertyID: {{ configuration?.spec?.property?.id }}">
        <span>{{ configuration?.spec?.description }}</span>
        <span class="mat-caption">{{ configuration?.spec?.property?.description }}</span>
      </div>
    </td>
  </ng-container>

  <!-- spec operator Column -->
  <ng-container matColumnDef="spec-operator">
    <th mat-header-cell *matHeaderCellDef style="width: 20%" mat-sort-header>
      {{ 'skillSets.constraints.operator' | translate }}
    </th>
    <td mat-cell *matCellDef="let configuration">
      {{ 'ConstraintOperator.' + configuration?.spec?.operator | translate }}
    </td>
  </ng-container>

  <!-- possible value Column -->
  <ng-container matColumnDef="possible-values">
    <th mat-header-cell *matHeaderCellDef style="width: 30%">
      {{ 'context.possible-values' | translate }}
    </th>
    <td mat-cell *matCellDef="let configuration; let i = index">
      @if (canSetPossibleValues(configuration)) {
        <app-property-input
          elderStopEventPropagation
          [name]="'possibleValues' + i"
          [property]="configuration.spec.property"
          [(values)]="configuration.possibleValues"
        >
        </app-property-input>
      }
    </td>
  </ng-container>

  <!-- current conf Column -->
  <ng-container matColumnDef="current-conf">
    <th mat-header-cell *matHeaderCellDef style="width: 20%" mat-sort-header>
      {{ 'context.value' | translate }}
    </th>
    <td mat-cell *matCellDef="let configuration; let i = index">
      <app-property-input
        elderStopEventPropagation
        [name]="'conf' + i"
        [property]="configuration.spec.property"
        [allowedValues]="configuration.possibleValues"
        [singleSelection]="configuration.spec.singleSelection"
        [required]="configuration.spec.required"
        [(values)]="configuration.activeConf.values"
      >
      </app-property-input>
    </td>
  </ng-container>
</elder-table>
